<template>
  <div
    class="md:flex md:align-baseline w-full items-center relative border-b-4 border-red-600"
  >
    <div class="py-2 px-10">
      <button
        class="outline-none focus:outline-none w-full"
        @click="route('/login')"
      >
        <img class="w-[100px]" src="../assets/images/logo2.png" alt="" />
      </button>
    </div>
    <div
      class="
      text-black
        font-sans font-light
        text-3xl
        bg-color
        md:items-center md:flex md:justify-center
        w-full
      "
    >
      BUYERS' INFORMATION SHEET
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    route(to) {
      if (to != this.$route.path) {
        this.$router.push(to);
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background: white;
}
</style>
